import { email, firstName, lastName, mobile } from '@/validations/components'

export const validations = (isTiny, hasContractOwner = false) => {
  const validator = {
    email
  }

  if (!isTiny) {
    const additionalValidations = hasContractOwner ? { mobile } : { firstName, lastName, mobile }
    Object.assign(validator, additionalValidations)
  }
  return { form: { ...validator } }
}
